import { createContext, useContext, useState } from 'react'
import fr from './fr'
import en from './en'

const TRANSLATIONS = { fr, en }
const LangContext = createContext({ lang: 'fr', t: fr, setLang: () => {} })

export function LangProvider({ children }) {
  const [lang, setLang] = useState('fr')
  return (
    <LangContext.Provider value={{ lang, t: TRANSLATIONS[lang], setLang }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() {
  return useContext(LangContext)
}
